import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchComp from "components/Searchcomponent";
import React from "react";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles(() => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles(() => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "14px",
    color: "#4f4f4f",
  },
}))(TableCell);

const HEADER_TITLES = [
  { title: "Account", align: "left", className: "audience-participants-text-head" },
  { title: "First name", align: "left", className: "audience-participants-text-head" },
  { title: "Last name", align: "left", className: "audience-participants-text-head" },
  { title: "Mobile number", align: "center" },
  { title: "Email", align: "center" },
];

const AudienceParticipantsTable = ({
  participants,
  searchValue,
  onSearchChange,
  hasContactValue,
  getParticipantFamilyName,
  audienceName,
  audienceCount,
}) => (
  <div className="audience-participants-table-section">
    <div className="audience-participants-table-meta">
      <span className="audience-participants-table-meta-item">
        <span className="audience-participants-table-meta-label">Name:</span>
        <span className="audience-participants-table-meta-value">
          {audienceName || "-"}
        </span>
      </span>
      <span className="audience-participants-table-meta-item">
        <span className="audience-participants-table-meta-label">Audience Count:</span>
        <span className="audience-participants-table-meta-value">
          {audienceCount ?? 0}
        </span>
      </span>
    </div>
    <div className="audience-participants-table-toolbar">
      <span className="info_box_audience-title">Participants:</span>
      <span className="finance-filter-serach-bar audience-participants-search">
        <SearchComp
          value={searchValue}
          setSearchText={onSearchChange}
          placeholder="Search"
          style={{ width: "20.5rem", backgroundColor: "#fff" }}
        />
      </span>
    </div>
    <div className="audience-participants-table-wrap">
      <TableContainer className="scroll-table">
        <Table aria-label="Audience participants">
          <TableHead className="charges-table sticky-table-header">
            <TableRow>
              {HEADER_TITLES.map(({ title, align, className = "" }) => (
                <TableCellHead
                  key={title}
                  className={`class__header__cell ${className}`.trim()}
                  align={align}
                >
                  <div>{title.toUpperCase()}</div>
                </TableCellHead>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: "white" }}>
            {participants.length === 0 ? (
              <TableRow>
                <TableCellBody colSpan={5} align="center">
                  No participants found
                </TableCellBody>
              </TableRow>
            ) : (
              participants.map((participant) => (
                <TableRow
                  key={
                    participant?._id ||
                    `${participant?.first_name}-${participant?.last_name}`
                  }
                >
                  <TableCellBody
                    className="class__body__cell audience-participants-text-cell"
                    align="left"
                  >
                    {getParticipantFamilyName(participant) || "-"}
                  </TableCellBody>
                  <TableCellBody
                    className="class__body__cell audience-participants-text-cell"
                    align="left"
                  >
                    {participant?.first_name || "-"}
                  </TableCellBody>
                  <TableCellBody
                    className="class__body__cell audience-participants-text-cell"
                    align="left"
                  >
                    {participant?.last_name || "-"}
                  </TableCellBody>
                  <TableCellBody align="center">
                    {hasContactValue(participant?.mobile_number) && (
                      <CheckCircleIcon
                        className="audience-summary-contact-icon"
                        titleAccess="Mobile available"
                        aria-label="Mobile available"
                      />
                    )}
                  </TableCellBody>
                  <TableCellBody align="center">
                    {hasContactValue(participant?.email_address) && (
                      <CheckCircleIcon
                        className="audience-summary-contact-icon"
                        titleAccess="Email available"
                        aria-label="Email available"
                      />
                    )}
                  </TableCellBody>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  </div>
);

export default AudienceParticipantsTable;
